import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { Label } from "reactstrap";
import { connect } from "react-redux";

import QuickResult from "./Components/QuickResult";
import { Services } from "../../../repositories/clients/Services";
import ContentWrapper from "../../template/Layout/ContentWrapper";
// import ClientesList from '../../../services/storageClient';
// const clientSave = new ClientesList();
import Loader from "./../../Global/Loader";
import { withNamespaces } from "react-i18next";
import Authentication from "../../../services/Authentication";

const auth = new Authentication();

class QuickSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      results: [],
      path: "",
      fullLoader: false,
      modules: JSON.parse(auth.getAuthentication("Modules") || "[]"),
    };
  }

  componentDidMount = () => {
    this.setState(
      { path: decodeURIComponent(this.props.match.params.id) },
      () => this.getQuickSearch()
    );
  };

  componentWillReceiveProps = (nextProps) => {
    this.setState(
      {
        path: decodeURIComponent(nextProps.match.params.id),
        fullLoader: false,
      },
      () => this.getQuickSearch()
    );
  };

  getQuickSearch = () => {
    const { path } = this.state;
    let timeStart;
    timeStart = Date.now();
    const data = {
      // cliente: this.state.clientesSelect
      cliente: this.props.clients ? JSON.stringify(this.props.clients) : "[0]",
      userId: this.props._user ? this.props._user : 0,
      lang: this.props.lng,
    };
    axios
      .post(`${Services.TRACEABILITY.path}quicksearch?q=${path}`, data)
      .then((response) => {
        //axios.post(`http://localhost:3020/quicksearch?q=${path}`, data).then((response) => {
        this.setState({
          data: response.data.message,
          sizeRes: response.data.message.Total,
          fullLoader: true,
        });
      })
      .catch((error) => {
        this.setState({
          fullLoader: true,
        });
        console.error("ERROR", error);
      });

    this.setState({ timeStart });
  };

  render() {
    const { timeStart, data, path, sizeRes, fullLoader, modules } = this.state;
    const timeEnddd = Date.now();
    const timeValue = (timeEnddd - timeStart) / 1000;

    return (
      <ContentWrapper>
        <Loader hidden={fullLoader}></Loader>

        <div className="col-12">
          <Label>
            {this.props.t("total_res")}: {sizeRes} ({timeValue}{" "}
            {this.props.t("secs")}) {this.props.t("for")} <b> "{path}" </b>
          </Label>
        </div>
        <QuickResult data={data} modules={modules} />
      </ContentWrapper>
    );
  }
}
const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(withRouter(QuickSearch)));
